import type { Access } from "./auth";

/** Days left in the free trial, counting a started day as a whole one (14 right after sign-up, 1 on the last day). */
export function trialDaysLeft(access: Access, now = Date.now()) {
  if (access.source !== "trial" || !access.trialEndsAt) return null;
  return Math.max(1, Math.ceil((new Date(access.trialEndsAt).getTime() - now) / 86400000));
}

/** True when the person had a trial that is over and they aren't paying. */
export const trialEnded = (access: Access, now = Date.now()) =>
  !access.plus && !!access.trialEndsAt && new Date(access.trialEndsAt).getTime() <= now;
